import { Routes } from '@angular/router';

import { extract } from '@personal-area/global/i18n';
import { Type } from '@personal-area/global/users/models';

import { TariffListComponent } from './pages/tariff-list/tariff-list.component';
import { TariffSetupComponent } from './pages/tariff-setup/tariff-setup.component';

export const ROUTES: Routes = [
  {
    path: '',
    data: { title: extract('dashboard.title') },
    children: [
      {
        path: 'real',
        component: TariffListComponent,
        data: {
          accountType: Type.Trader,
          title: extract('open-account.title-trader'),
        },
      },
      {
        path: 'real/:tariff',
        component: TariffSetupComponent,
        data: {
          accountType: Type.Trader,
          title: extract('open-account.title-trader'),
        },
      },
      {
        path: 'demo',
        component: TariffListComponent,
        data: {
          accountType: Type.Demo,
          title: extract('open-account.title-demo'),
        },
      },
      {
        path: 'demo/:tariff',
        component: TariffSetupComponent,
        data: {
          accountType: Type.Demo,
          title: extract('open-account.title-demo'),
        },
      },
      {
        path: ':id',
        data: { title: extract('account.routing.title') },
        loadChildren: () =>
          import('./pages/home/pages/home.module').then((m) => m.HomeModule),
      },
    ],
  },
];
